import PropTypes from "prop-types";
import React from "react";
import Button from "../../components/common/buttons/Button";
import ButtonBar from "../../components/common/buttons/ButtonBar";
import * as ButtonBarPositions from "../../constants/ButtonBarPositions";
import * as bpieLocations from "./bpieLocations";

export const BpieAdminNavigation = ({ currentLocation, history }) => {
    const navButtonClick = (event, location) => {
        event.preventDefault();

        if (currentLocation.startsWith(location)) return;

        history.push(location);
    };

    const sbpieSummaryUrl = bpieLocations.STATE_SBPIE_SEARCH.getUrl();
    const dbpieSummaryUrl = bpieLocations.STATE_DBPIE_SEARCH.getUrl();

    return (
        <ButtonBar position={ButtonBarPositions.STICKY_BOTTOM} className={`bpieAdminNavigation`}>
            <Button
                btnClass={currentLocation.startsWith(sbpieSummaryUrl) ? "is-active" : ""}
                label={`SBPIE Assessments`}
                name={`btnSbpieList`}
                onClick={(event) => navButtonClick(event, sbpieSummaryUrl)}
            />
            <Button
                btnClass={currentLocation.startsWith(dbpieSummaryUrl) ? "is-active" : ""}
                label={`DBPIE Assessments`}
                name={`btnSbpieList`}
                onClick={(event) => navButtonClick(event, dbpieSummaryUrl)}
            />
        </ButtonBar>
    );
};

BpieAdminNavigation.propTypes = {
    currentLocation: PropTypes.string,
    history: PropTypes.object
};
